import React from 'react';

import BuildingSaleBoitage from '../../components/Communication/BuildingSaleBoitage/BuildingSaleBoitage.module';

function BuildingSaleBoitageView() {
  return (
    <BuildingSaleBoitage />
  );
}

export default BuildingSaleBoitageView;


